import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './kpi-row.types';

export const kpiRowSelectors = {
  ...generateResourceSelectors<types.IKpiRow>((state) => state.resource.kpiRow),
};
